import React from "react";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AUTH, MAIN } from "../../Router/paths";
import logo from "../../assets/images/logo.png";

export default function Header() {
  return (
    <>
      {/* MOBILE-MENU START */}
      <div className="mobile-menu">
        <div className="mobile-close">
          <Link to="#" id="menu-close">
            <FaTimes />
          </Link>
        </div>
        <div className="mobile-menu-body" id="mobile-menu-body" />
      </div>
      {/* MOBILE-MENU END */}
      {/* HEADER CSS START */}
      <header className="header" id="header">
        <div className="bottom-row">
          <div className="container-fluid px-5">
            <div className="row align-items-center">
              <div className="col-lg-1 col-12">
                <div className="logo">
                  <Link to={MAIN.landing}>
                    <img src={logo} alt="Logo" />
                  </Link>
                </div>
              </div>
                <div className="col-lg-11">
                  <ul className="login-btns">
                    <li>
                      <Link to={AUTH.login}>Log In</Link>
                    </li>
                    <li>
                      <Link to={AUTH.signup} className="primary-btn primary-bg">
                        Sign Up
                      </Link>
                    </li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
      </header>
      {/* HEADER END */}
    </>
  );
}
